import styled from 'styled-components';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';

export const BracketedWrapper = styled(Horizontal).attrs({ center: true })`
  position: relative;
  padding: 0 var(--intermediate-unit);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border: 1.5px solid var(--border-color, currentColor);
    border-radius: 4px;
    mask:
      linear-gradient(#fff, #fff) 0 0,
      linear-gradient(#fff, #fff) 100% 0,
      linear-gradient(#fff, #fff) 100% 100%,
      linear-gradient(#fff, #fff) 0 100%;
    mask-size: var(--unit) var(--unit);
    mask-repeat: no-repeat;
  }
`;
